export const IgnoredFiles: string[] = [
  '.DS_Store',
];

/** Filesystem folder name where asset packs live at the project root (`<project>/packs/`). */
export const PACKS_FOLDER_NAME = 'packs';

/**
 * TypeScript import-path namespace prefix for asset packs (`@packs/<name>/...`).
 *
 * @remarks
 * This value is also hardcoded in the template file
 * `src/templates/.genesys/sdk/vite.config.ts` (the `collectPackAliases` function),
 * which is copied verbatim into user projects and cannot import from this module.
 * If you change this constant, update that file manually.
 */
export const PACKS_TS_NAMESPACE = '@packs';

export const installCommand = 'pnpm install';
export const buildCommand = 'pnpm turbo:build';
export const gitInitCommand = 'git init && git add . && git commit -m "Initial Commit"';
